import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList";

export const FigureDesc64 = {
    title: "Figure 64: Typical floor plan of a library. ",
    para1: <>
        <p>
            <span><b>Orientation of the floor plan: </b></span>
            The descriptions of the figure are described in an anti clockwise manner from the entrance. The entrance to the library is at the left middle of the plan.
        </p>
        <p>
            <span><b>Description: </b></span>
            <p>
                Reception Area
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Outside the library, to the left of the entrance is a receptionist desk along with 2 chairs.",

                        "To the right of the receptionist is a provision of a shelf. Next to the shelf is placed a three seater chair for people waiting outside the library for some queries."
                    ])}
                </div>
            </p>

            <p>
                Head Librarian’s Office
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Upon entering the library, to the left is a seating area. The seating/waiting area has a three seater couch placed at a right angle along with a couch. This is for persons waiting to meet the Head Librarian.",

                        "Behind this, there is an Office of the Head Librarian. There is a table for the Head Librarian along with chairs for them and for people visiting them. A sofa set with a centre table has also been placed within the room."
                    ])}
                </div>
            </p>

            <p>
                Office Area
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Next to the Head Librarian’s office, there is an office space. The entrance is to the bottom right of the office area. To the right of the entrance is a storage space and a xerox machine.",
                        "The office area has two rows of tables with three chairs on each side of the table (including wheelchair accessible seating). Every table has a computer system.",
                        "Behind the tables is a space for storage.",

                    ])}
                </div>
            </p>

            <p>
                Enclosed Reading Area
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Next to the office area is a reading room. The entrance is at the bottom right of the space.",
                        "The reading room has four cabins along with access doors. Each cabin has a chair and a table.  One of the cabins is wheelchair friendly.",

                    ])}
                </div>
            </p>

            <p>
                Digital Library
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "A Digital Library is located beside the reading room. The Digital Library room has two columns of tables with 6 chairs (including wheelchair accessible seating).  Each table has a computer system."
                    ])}
                </div>
            </p>

            <p>
                Accessible Washroom Facilities
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "Beside the digital facilities, three accessible washrooms and drinking water facilities have been provided.",
                        "The access door to the washroom is at the bottom right corner of the space. ",
                        "The washroom has three stalls. Two of the stalls have Indian WCs, a sink and a diaper changing area. One of the stalls has a western WC, a sink and a diaper changing area. ",
                        "Outside the washroom is a drinking water facility.",

                    ])}
                </div>
            </p>

            <p>
                Library Floor
                <div className="figure_desc">
                    {generateUnOrderedList([
                        "The middle of the room has 2 curved benches placed adjacent to each other. There is a potted plant between the two benches.",
                        "Below the shelves are 6 columns of shelves. Aisle space between the shelves is 1200 mm.  Each column has two shelves.",
                        "There are two shelves placed in two rows beside the column of shelves. Each row has two shelves, one at the top and one at the bottom. The aisle space between the two shelves is 1200 mm.",
                        "Next to the shelves are three tables with a two seater couch on either side of the table. This is on the right side of the floor plan. There are potted plants placed between two tables.",
                        "Below these shelves are seven reading desks with four chairs on each desk (including accessible seating).",
                        "The bottom left wall of the room also has a shelf.",

                    ])}
                </div>
            </p>
        </p>
    </>
}

